"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

require("../../lang");

require("./style/upload-progress.scss");

var UploadProgress = function UploadProgress(_ref) {
  var files = _ref.files,
      erroredFiles = _ref.erroredFiles,
      progressStates = _ref.progressStates,
      active = _ref.active;

  var getHeaderMessage = function getHeaderMessage() {
    var gotErrors = files.filter(function (file) {
      return file.skip;
    });
    var uploadAmount = progressStates.filter(function (i) {
      return i < 1;
    }).length;
    var fileString = uploadAmount === 1 ? 'file' : 'files'; // if we have multiple errors, show complete with errors (some went through)

    if (gotErrors.length > 0 && gotErrors.length !== 1) {
      return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "imagepicker.uploadCompleteWithErrors"
      });
    } // if we have only one error. Show Errors while uploading (none did go through)


    if (gotErrors.length === 1) {
      return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "imagepicker.uploadErrors"
      });
    }

    if (uploadAmount > 0) {
      return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "imagepicker.uploadingNumFiles",
        values: [uploadAmount, fileString]
      });
    }

    if (uploadAmount === 0) {
      return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "imagepicker.uploadComplete"
      });
    }
  };

  var currentFiles = files.map(function (file, i) {
    var percentage = progressStates[i] === 1 ? '100%' : /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      size: 15
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "file",
      key: i
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "file-name"
    }, file.file.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress"
    }, percentage));
  });
  var errored = erroredFiles.map(function (file, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "file",
      key: "".concat(i, "-errors")
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "file-name"
    }, /*#__PURE__*/_react["default"].createElement("s", null, file.file.name)), file.errorComponents);
  });
  var isUploading = progressStates.every(function (i) {
    return i === 1;
  }); // some files have a skip. So we have errors say from files too big

  var gotErrors = files.filter(function (file) {
    return file.skip;
  }).length > 0;
  var topbarClasses = (0, _classnames["default"])('topbar', {
    success: isUploading && !gotErrors,
    warning: isUploading && gotErrors // TODO: determine when a file is not uploaded properly

  });
  var statusContainerClass = (0, _classnames["default"])('status-container', {
    success: !gotErrors,
    error: gotErrors
  });
  var uploadProgressClass = (0, _classnames["default"])('upload-progress', {
    active: active
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: uploadProgressClass
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: topbarClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-container"
  }, getHeaderMessage()), isUploading && /*#__PURE__*/_react["default"].createElement("div", {
    className: statusContainerClass
  }, gotErrors ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "close"
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "done"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "upload-files"
  }, [].concat((0, _toConsumableArray2["default"])(currentFiles), (0, _toConsumableArray2["default"])(errored))));
};

UploadProgress.propTypes = {
  files: _propTypes["default"].array,
  erroredFiles: _propTypes["default"].array,
  progressStates: _propTypes["default"].array,
  active: _propTypes["default"].bool
};
var _default = UploadProgress;
exports["default"] = _default;